import {
  Checkbox,
  CircularProgress,
  FormControl,
  IconButton,
  Snackbar,
  styled,
} from "@mui/material";
import classes from "./Signup.module.css";

import Box from "@mui/material/Box";
import DeleteIcon from "@mui/icons-material/Delete";
import Text from "../../components/Text/Text";
import Input from "../../components/Input/Input";
import {
  LinkButton,
  LinkButtonForTermsAndCondition,
  LinkButtonWithText,
  SubmitButton,
} from "../../components/Button/Button";
import google from "../../assets/images/google.png";
import facebook from "../../assets/images/fb.png";
import apple from "../../assets/images/apple.png";
import {
  appleProvider,
  facebookProvider,
  googleProvider,
} from "../../config/authMethods";
import {
  createUser,
  socialMediaAuth,
  termsAndConditionContent,
} from "../../services/auth";
import { isValidEmail, isValidPassword } from "../../validations/Email/Email";
import { useEffect, useState } from "react";
import {
  createUserWithEmailAndPassword,
  OAuthProvider,
  signInWithPopup,
  signInWithRedirect,
} from "firebase/auth";
import { auth } from "../../config/firebase";
import { useNavigate } from "react-router-dom";
import useNotifications from "../../Hooks/useNotifications";
import checkedIcon from "../../../src/assets/images/Vector.png";
import Google from "../../assets/Svg/Google.svg";
import Facebook from "../../assets/Svg/Facebook.svg";
import Apple from "../../assets/Svg/Apple.svg";
import SixDigitCode from "../Passcode/SixDigitCode";
import { useDispatch } from "react-redux";
import { updateImageUrl, updateName, updateSurName } from "../../Store/Reducers/onbordingSlice";

const label = { inputProps: { "aria-label": "Checkbox demo" } };
export default function Signup() {
  const dispatch = useDispatch()
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [surName, setSurname] = useState("");
  const [password, setPassword] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [errorName, setErrorName] = useState("");
  const [errorSurName, setErrorSurName] = useState("");
  const [errorPassword, setErrorPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [termsAndConditions, setTermsAndConditions] = useState(false);
  const [termsAndConditionUrl, settermsAndConditionUrl] = useState("");
  const [isCode, setIsCode] = useState(window.x_version ? true : localStorage.getItem("bypassCode") === "true");
  const [isCheckboxError, setIsCheckboxError] = useState(false)
  const [signedUpWithGoogleApple, setSignedUpWithGoogleApple] = useState(false)
  const { Notification, updateNotificationState, action } =
    useNotifications(false);
  let navigate = useNavigate();
  const changeTermsAndCondition = (val) => {
    setIsCheckboxError(!val)
    setTermsAndConditions(val)
  }
  useEffect(() => {
    termsAndConditionContent()
      .then((data) => {
        console.log(data);
        settermsAndConditionUrl(data?.policyAndConditionsData?.conditionsUrl);
      })
      .catch((err) => {
        console.log(err);
      });
    if (window.location.origin.includes('-x')) {
      setIsCode(true)
    }
  }, []);

  const createNewUser = async (result, isGoogleApple) => {
    const userDataRes = {
      uid: result?.user?.uid ? result?.user?.uid : result?.uid,
      user_email: result?.user?.email ? result?.user?.email : result?.email,
      name: name,
      surName: surName,
      platform: window.location.origin,
      domain: window.location.origin.includes('app.flourish-labs.com') ? "FlourishLabs_WEB" : window.location.origin.includes('appx.scientific-selfdiscovery.com') ? "SSD_WEB" : "OTHER",
      "ipAddress": localStorage.getItem("ipAddress")
    };
    if (result.photoURL) {
      userDataRes.imageUrl = result.photoURL
    }
    if (window.location.origin.includes('app.scientific-selfdiscovery.com')) {
      userDataRes.platform = window.location.origin
    }
    setIsLoading(true);
    createUser(userDataRes)
      .then((data) => {
        console.log(data);
        localStorage.setItem("userDetail", data.data.uid);
        localStorage.setItem("userEmail", data.data.user_email);
        localStorage.setItem("name", name);
        localStorage.setItem("surName", surName);
        // updateNotificationState(data.message);
        dispatch(updateName(name))
        dispatch(updateSurName(surName))
        if (result.photoURL) {
          dispatch(updateImageUrl(result.photoURL))
        } else {
          dispatch(updateImageUrl(""))
        }
        if (isGoogleApple) {
          setEmail(data.data.user_email)
          setSignedUpWithGoogleApple(true)
          localStorage.setItem("bypassCode", true)
        } else {
          navigate("/onbording");
        }
      })
      .catch((error) => {
        console.log(12, error.response);
        if (error.response.data.description === "Uid is already registered") {
          updateNotificationState("User is alredy registered");
          // setErrorEmail("User is alredy registered")
          // navigate("/");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleOnClick = async (provider) => {
    try {
      const result = await socialMediaAuth(provider);
      console.log("result ===", result);
      if (!result.uid) {
        throw new Error(result.message);
      } else {
        if (result.displayName) {
          const splitted = result.displayName.split(" ")
          setName(splitted[0])
          setSurname(splitted[1])
        }
        if (result.photoURL) {

        }
        createNewUser(result, true);
      }
    } catch (error) {
      if (!error.message.includes("auth/popup-closed-by-user")) {
        updateNotificationState(error?.message);
      }
      setIsLoading(false);
    }
  };

  const emailAuth = async (email, password) => {
    return createUserWithEmailAndPassword(auth, email, password)
      .then((result) => {
        console.log(result);
        localStorage.setItem("allUserDetails", JSON.stringify(result));
        return result;
      })
      .catch((err) => {
        setIsLoading(false);
        // updateNotificationState("User is alredy registered");
        setErrorEmail("User is alredy registered");
        setPassword("");
        console.log("----------", err);
        return err;
      });
  };

  const firebaseLogin = async () => {
    // setShowLoader(true);
    try {
      const result = await emailAuth(email, password);
      console.log("res 82", result);
      if (result.user) {
        createNewUser(result);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(">>>", error);
    }
  };

  const handleSubmit = () => {
    if (!termsAndConditions) {
      setIsCheckboxError(true)
      return
    }
    setIsLoading(true);
    firebaseLogin();
    setIsCode(true)

  };

  const handleNext = () => {
    localStorage.setItem("name", name);
    localStorage.setItem("surName", surName);
    dispatch(updateName(name))
    dispatch(updateSurName(surName))
    navigate("/onbording");
  }

  console.log(termsAndConditions);

  const CheckboxIcon = () => {
    return (
      <div
        style={{
          border: "1px solid #E5D5FC",
          borderRadius: "8px",
          padding: "11px",
        }}
      ></div>
    );
  };

  const CheckboxCheckedIcon = () => {
    return (
      <div
        style={{
          border: "1px solid #E5D5FC",
          borderRadius: "8px",
          padding: "2px",
          paddingLeft: "3px",
          paddingRight: "3px",
        }}
      >
        <img src={checkedIcon} alt="" />
      </div>
    );
  };

  const signinWithApple = async () => {
    // signInWithRedirect(auth, appleProvider)
    signInWithPopup(auth, appleProvider)
      .then((result) => {
        const user = result.user;
        console.log(result);
        const credential = OAuthProvider.credentialFromResult(result);
        const accessToken = credential.accessToken;
        const idToken = credential.idToken;

        if (!user.uid) {
          throw new Error(result.message);
        }
        createNewUser(result, true);
      })
      .catch((error) => {
        console.log(error);
        const errorCode = error.code;
        const errorMessage = error.message;
        const email = error.customData.email;
        const credential = OAuthProvider.credentialFromError(error);
        console.log(error, credential);
        setErrorPassword("Invalid credentials");
        setErrorEmail("Invalid credentials");
        setIsLoading(false);
      });
  };

  const TermsAndCondition = styled(Box)(({ theme }) => ({
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: "-2px",
    marginLeft: "3px",

    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "140%",

    [theme.breakpoints.up("xl")]: {
      marginTop: "-2px",
    },
    [theme.breakpoints.down("lg")]: {
      marginTop: "-2px",
    },
    [theme.breakpoints.down("md")]: {
      marginTop: "-2px",
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "-4px",
    },
  }));
  return (
    <>
      {!isCode ? (
        <SixDigitCode setIsCode={setIsCode} />
      ) : (
        <>
          <Box className={classes.brandBox} sx={{ mb: "16px", py: "1px" }}>
            {!window.florishApp && <Text textValue={`${window.florishApp ? "FlourishLabs" : "Scientific Self-Discovery"}`} variant="h6" color={window.florishApp ? "#000" : "#9747FF"} otherSx={{
              fontSize: window.florishApp ? "2.5rem" : "18px",
              fontWeight: 500
            }} />}
            {window.florishApp && <svg xmlns="http://www.w3.org/2000/svg" width="300" height="40" viewBox="0 0 300 40" fill="none">
              <path d="M0.505005 38.6286V2.22344H23.8271V7.75177H7.09988V17.6352H22.2273V23.1635H7.09988V38.6286H0.505005ZM35.4854 2.22344V38.6286H29.0503V2.22344H35.4854ZM53.5118 39.162C50.8454 39.162 48.5344 38.5752 46.5791 37.402C44.6237 36.2288 43.1068 34.5876 42.0285 32.4781C40.9618 30.3688 40.4285 27.9039 40.4285 25.0834C40.4285 22.2629 40.9618 19.792 42.0285 17.6708C43.1068 15.5495 44.6237 13.9023 46.5791 12.7291C48.5344 11.5558 50.8454 10.9692 53.5118 10.9692C56.1782 10.9692 58.4889 11.5558 60.4443 12.7291C62.3996 13.9023 63.9107 15.5495 64.9772 17.6708C66.0557 19.792 66.5948 22.2629 66.5948 25.0834C66.5948 27.9039 66.0557 30.3688 64.9772 32.4781C63.9107 34.5876 62.3996 36.2288 60.4443 37.402C58.4889 38.5752 56.1782 39.162 53.5118 39.162ZM53.5472 34.0069C54.9931 34.0069 56.2017 33.6098 57.1735 32.816C58.1454 32.01 58.8681 30.9317 59.3422 29.5806C59.8282 28.2297 60.0711 26.7246 60.0711 25.0657C60.0711 23.3946 59.8282 21.8837 59.3422 20.5328C58.8681 19.1699 58.1454 18.0855 57.1735 17.2797C56.2017 16.4739 54.9931 16.0709 53.5472 16.0709C52.066 16.0709 50.8335 16.4739 49.8499 17.2797C48.8782 18.0855 48.1492 19.1699 47.6634 20.5328C47.1894 21.8837 46.9524 23.3946 46.9524 25.0657C46.9524 26.7246 47.1894 28.2297 47.6634 29.5806C48.1492 30.9317 48.8782 32.01 49.8499 32.816C50.8335 33.6098 52.066 34.0069 53.5472 34.0069ZM88.9587 27.1453V11.3247H95.3935V38.6286H89.1541V33.7758H88.8696C88.2535 35.3044 87.2403 36.5548 85.8301 37.5266C84.4317 38.4983 82.7074 38.9843 80.6571 38.9843C78.8678 38.9843 77.2858 38.5871 75.9111 37.7931C74.5483 36.9874 73.4817 35.82 72.7114 34.2914C71.9411 32.7507 71.5559 30.8902 71.5559 28.7096V11.3247H77.9908V27.7141C77.9908 29.4444 78.4648 30.8191 79.4128 31.8382C80.361 32.8575 81.6053 33.367 83.1458 33.367C84.094 33.367 85.0123 33.1359 85.901 32.6737C86.79 32.2115 87.5187 31.5243 88.0875 30.6116C88.6682 29.6874 88.9587 28.5319 88.9587 27.1453ZM101.51 38.6286V11.3247H107.749V15.8754H108.034C108.531 14.2993 109.385 13.0846 110.594 12.2313C111.814 11.3662 113.207 10.9337 114.771 10.9337C115.126 10.9337 115.523 10.9514 115.962 10.987C116.412 11.0107 116.785 11.0522 117.082 11.1114V17.0308C116.809 16.936 116.377 16.8531 115.784 16.782C115.203 16.699 114.641 16.6575 114.096 16.6575C112.922 16.6575 111.868 16.9123 110.931 17.4219C110.007 17.9196 109.278 18.6129 108.745 19.5017C108.212 20.3905 107.945 21.4157 107.945 22.577V38.6286H101.51ZM120.856 38.6286V11.3247H127.291V38.6286H120.856ZM124.092 7.44959C123.072 7.44959 122.195 7.11183 121.461 6.43635C120.726 5.749 120.359 4.9254 120.359 3.96549C120.359 2.99373 120.726 2.17013 121.461 1.49462C122.195 0.807292 123.072 0.463623 124.092 0.463623C125.122 0.463623 126 0.807292 126.722 1.49462C127.457 2.17013 127.825 2.99373 127.825 3.96549C127.825 4.9254 127.457 5.749 126.722 6.43635C126 7.11183 125.122 7.44959 124.092 7.44959ZM154.988 18.5418L149.122 19.1817C148.956 18.5892 148.665 18.0322 148.251 17.5108C147.848 16.9894 147.303 16.5687 146.615 16.2487C145.928 15.9287 145.087 15.7687 144.091 15.7687C142.752 15.7687 141.626 16.0591 140.714 16.6398C139.813 17.2205 139.369 17.973 139.38 18.8973C139.369 19.6913 139.659 20.3371 140.252 20.835C140.856 21.3326 141.851 21.7414 143.238 22.0614L147.895 23.0569C150.479 23.6138 152.398 24.4967 153.655 25.7056C154.923 26.9142 155.563 28.4962 155.574 30.4516C155.563 32.17 155.059 33.687 154.063 35.0024C153.08 36.306 151.711 37.3251 149.957 38.0599C148.203 38.7945 146.189 39.162 143.913 39.162C140.572 39.162 137.881 38.4628 135.843 37.0644C133.805 35.6542 132.59 33.6928 132.199 31.1806L138.474 30.5761C138.758 31.8086 139.363 32.7388 140.287 33.367C141.211 33.995 142.414 34.3091 143.896 34.3091C145.424 34.3091 146.651 33.995 147.575 33.367C148.511 32.7388 148.98 31.9627 148.98 31.0383C148.98 30.2562 148.677 29.6102 148.073 29.1007C147.48 28.5911 146.556 28.2001 145.3 27.9275L140.643 26.9499C138.024 26.4047 136.086 25.4863 134.83 24.1945C133.574 22.8909 132.952 21.2438 132.963 19.2528C132.952 17.57 133.408 16.1124 134.332 14.8799C135.268 13.6356 136.566 12.6757 138.225 12.0002C139.896 11.3129 141.822 10.9692 144.002 10.9692C147.202 10.9692 149.72 11.6506 151.557 13.0135C153.406 14.3763 154.549 16.2191 154.988 18.5418ZM166.815 22.6302V38.6286H160.38V2.22344H166.673V15.9643H166.993C167.632 14.4237 168.622 13.209 169.961 12.3202C171.312 11.4196 173.031 10.9692 175.116 10.9692C177.012 10.9692 178.665 11.3662 180.076 12.1602C181.486 12.9542 182.576 14.1156 183.346 15.6443C184.129 17.173 184.52 19.0395 184.52 21.2438V38.6286H178.085V22.2391C178.085 20.4024 177.611 18.9743 176.663 17.9552C175.727 16.9242 174.411 16.4087 172.716 16.4087C171.579 16.4087 170.56 16.6575 169.659 17.1553C168.77 17.6411 168.071 18.3463 167.562 19.2706C167.064 20.1949 166.815 21.3149 166.815 22.6302ZM190.863 38.6286V2.22344H197.458V33.1002H213.493V38.6286H190.863ZM226.289 39.1797C224.557 39.1797 222.999 38.8716 221.612 38.2553C220.238 37.6273 219.147 36.7029 218.342 35.4823C217.547 34.2616 217.151 32.7567 217.151 30.9672C217.151 29.4267 217.435 28.1527 218.004 27.1453C218.574 26.1381 219.349 25.3322 220.332 24.7278C221.316 24.1235 222.424 23.6672 223.656 23.3591C224.902 23.0392 226.186 22.8081 227.515 22.6658C229.115 22.4998 230.412 22.3517 231.407 22.2214C232.402 22.0791 233.126 21.866 233.576 21.5815C234.037 21.2853 234.269 20.8289 234.269 20.2128V20.106C234.269 18.7669 233.872 17.73 233.078 16.9953C232.285 16.2605 231.14 15.8932 229.647 15.8932C228.072 15.8932 226.82 16.2368 225.896 16.9242C224.985 17.6115 224.368 18.4233 224.049 19.3595L218.04 18.5062C218.513 16.8472 219.295 15.4606 220.386 14.3467C221.477 13.2208 222.81 12.3794 224.386 11.8225C225.961 11.2536 227.703 10.9692 229.611 10.9692C230.927 10.9692 232.237 11.1233 233.541 11.4314C234.844 11.7395 236.035 12.2491 237.113 12.9601C238.192 13.6593 239.057 14.6133 239.708 15.8221C240.371 17.0308 240.703 18.5418 240.703 20.3549V38.6286H234.519V34.8779H234.304C233.914 35.6363 233.363 36.3473 232.652 37.011C231.951 37.6627 231.069 38.1902 230.003 38.5932C228.948 38.9843 227.709 39.1797 226.289 39.1797ZM227.959 34.4514C229.25 34.4514 230.37 34.1965 231.317 33.687C232.266 33.1655 232.994 32.4781 233.505 31.6248C234.027 30.7718 234.287 29.8413 234.287 28.8341V25.6167C234.085 25.7825 233.741 25.9367 233.255 26.0789C232.781 26.2209 232.247 26.3455 231.655 26.452C231.063 26.5588 230.477 26.6535 229.897 26.7365C229.315 26.8195 228.812 26.8907 228.385 26.9499C227.425 27.0802 226.566 27.2934 225.807 27.5898C225.05 27.886 224.451 28.3008 224.013 28.8341C223.573 29.3556 223.354 30.0309 223.354 30.8606C223.354 32.0457 223.788 32.9403 224.651 33.5447C225.517 34.1492 226.62 34.4514 227.959 34.4514ZM246.958 38.6286V2.22344H253.392V15.8398H253.659C253.991 15.1762 254.46 14.4711 255.063 13.7245C255.668 12.9661 256.486 12.3202 257.518 11.7869C258.548 11.2418 259.864 10.9692 261.464 10.9692C263.573 10.9692 265.475 11.5084 267.169 12.5868C268.877 13.6534 270.226 15.2355 271.223 17.333C272.231 19.4187 272.733 21.9784 272.733 25.0123C272.733 28.0105 272.241 30.5584 271.259 32.656C270.274 34.7534 268.935 36.3533 267.242 37.4554C265.546 38.5575 263.627 39.1086 261.481 39.1086C259.917 39.1086 258.619 38.8479 257.589 38.3264C256.556 37.805 255.728 37.177 255.099 36.4422C254.483 35.6955 254.004 34.9905 253.659 34.3269H253.286V38.6286H246.958ZM253.269 24.9766C253.269 26.7424 253.518 28.2889 254.016 29.6163C254.525 30.9434 255.253 31.9804 256.202 32.7271C257.161 33.4617 258.323 33.8292 259.685 33.8292C261.107 33.8292 262.298 33.4498 263.258 32.6914C264.219 31.9212 264.941 30.8723 265.427 29.5451C265.926 28.2059 266.174 26.6831 266.174 24.9766C266.174 23.282 265.932 21.7771 265.446 20.4617C264.96 19.1462 264.236 18.1152 263.277 17.3686C262.317 16.622 261.12 16.2487 259.685 16.2487C258.311 16.2487 257.145 16.6101 256.183 17.333C255.224 18.0559 254.496 19.0691 253.997 20.3728C253.511 21.6764 253.269 23.211 253.269 24.9766ZM299.284 18.5418L293.417 19.1817C293.25 18.5892 292.961 18.0322 292.545 17.5108C292.143 16.9894 291.599 16.5687 290.91 16.2487C290.224 15.9287 289.381 15.7687 288.387 15.7687C287.048 15.7687 285.921 16.0591 285.01 16.6398C284.109 17.2205 283.664 17.973 283.677 18.8973C283.664 19.6913 283.954 20.3371 284.547 20.835C285.152 21.3326 286.146 21.7414 287.533 22.0614L292.191 23.0569C294.775 23.6138 296.694 24.4967 297.95 25.7056C299.218 26.9142 299.858 28.4962 299.871 30.4516C299.858 32.17 299.355 33.687 298.358 35.0024C297.376 36.306 296.006 37.3251 294.254 38.0599C292.5 38.7945 290.485 39.162 288.209 39.162C284.868 39.162 282.177 38.4628 280.14 37.0644C278.1 35.6542 276.886 33.6928 276.494 31.1806L282.77 30.5761C283.053 31.8086 283.658 32.7388 284.582 33.367C285.506 33.995 286.71 34.3091 288.19 34.3091C289.719 34.3091 290.946 33.995 291.872 33.367C292.806 32.7388 293.275 31.9627 293.275 31.0383C293.275 30.2562 292.973 29.6102 292.368 29.1007C291.776 28.5911 290.852 28.2001 289.596 27.9275L284.939 26.9499C282.319 26.4047 280.382 25.4863 279.126 24.1945C277.868 22.8909 277.247 21.2438 277.259 19.2528C277.247 17.57 277.704 16.1124 278.627 14.8799C279.564 13.6356 280.861 12.6757 282.522 12.0002C284.192 11.3129 286.117 10.9692 288.297 10.9692C291.498 10.9692 294.016 11.6506 295.853 13.0135C297.701 14.3763 298.844 16.2191 299.284 18.5418Z" fill="#190D1A" />
            </svg>}
          </Box>
          <Box className={classes.wrapper} sx={{ mb: "16px", py: "1px", mt: window.florishApp ? '55px':'32px' }}>
            <Text textValue={signedUpWithGoogleApple ? "Let’s set up your account" : "Create an account"} variant="h2" otherSx={{
          fontSize: window.florishApp ? "2.3rem !important" : "2.5rem",
          fontWeight: 600
        }}/>
          </Box>
          <Box className={classes.wrapper}>
            <Input
              placeholder="Email"
              value={email}
              onChange={setEmail}
              validationFunction={isValidEmail}
              type="text"
              autoComplete='off'
              disabled={signedUpWithGoogleApple}
              errorMessage={errorEmail}
              setErrorMessage={setErrorEmail}
            />
          </Box>
          <Box className={classes.wrapper} style={{
            gap: '16px'
          }}>
            <Input
              placeholder="Name"
              value={name}
              onChange={setName}
              type="text"
              autoComplete='off'
              errorMessage={errorName}
              setErrorMessage={setErrorName}
            />
            <Input
              placeholder="Surname"
              value={surName}
              onChange={setSurname}
              type="text"
              autoComplete='off'
              errorMessage={errorSurName}
              setErrorMessage={setErrorSurName}
            />
          </Box>
          {signedUpWithGoogleApple ? <Box sx={{ width: "100%" }}>
            <SubmitButton
              buttonText="Next"
              isDisabled={isLoading ? false : (!email ||
                !name ||
                !surName ||

                errorEmail ||
                errorName ||
                errorSurName)
              }
              onClick={handleNext}
              isLoading={isLoading}
            />
          </Box>
            : (
              <>
                <Box className={classes.wrapper}>
                  <Input
                    placeholder="Password"
                    value={password}
                    onChange={setPassword}
                    validationFunction={isValidPassword}
                    type="password"
                    autoComplete='off'

                    errorMessage={errorPassword}
                    setErrorMessage={setErrorPassword}
                  />
                </Box>
                <TermsAndCondition className={classes.terms_and_condition}>
                  <Checkbox
                    {...label}
                    disableRipple
                    sx={{ pl: "0", width: "20px", height: "20px", borderColor: isCheckboxError && "red" /* background: "red" */ }}
                    checked={termsAndConditions}
                    onChange={(e) => changeTermsAndCondition(e.target.checked)}
                    icon={<CheckboxIcon />}
                    checkedIcon={<CheckboxCheckedIcon />}
                  />

                  <span style={{ color: "#434243", paddingLeft: "12px" }}>
                    By creating an account you are agree to our{" "}
                    <LinkButtonForTermsAndCondition
                      termsAndConditionUrl={termsAndConditionUrl}
                      buttonText="Terms & Conditions"
                      color="#000000"
                      textDecoration="underline"
                    />
                  </span>
                </TermsAndCondition>
                {isCheckboxError && <p style={{
                  color: "red",
                  fontSize: '12px'
                }}>Please select the checkbox to agree to our Terms & Conditions</p>}
                <Box sx={{ width: "100%" }}>
                  <SubmitButton
                    buttonText="Sign up"
                    isDisabled={isLoading ? false : (
                      !email ||
                      !name ||
                      !surName ||
                      !password ||
                      errorEmail ||
                      errorName ||
                      errorSurName ||
                      errorPassword)/* ||
                !termsAndConditions */
                    }
                    onClick={handleSubmit}
                    isLoading={isLoading}
                  />
                </Box>

                <Box className={`${classes.wrapper} ${classes.orText}`}>or</Box>
                <Box
                  className={classes.wrapper}
                  sx={{ gap: "12px", padding: "16px" }}
                >
                  <Box
                    className={classes.imgIcon}
                    onClick={() => handleOnClick(googleProvider)}
                  >
                    <img src={Google} alt="" />
                  </Box>

                  <Box className={classes.imgIcon} onClick={() => signinWithApple()}>
                    <img src={Apple} alt="" />
                  </Box>

                  <Box
                    className={classes.imgIcon}
                    onClick={() => handleOnClick(facebookProvider)}
                  >
                    <img src={Facebook} alt="" />
                  </Box>
                </Box>
                <Box className={classes.wrapper}>
                  <LinkButtonWithText
                    text="Already a user?"
                    buttonText="Log in"
                    navigateUrl="/"
                  />
                </Box>
              </>
            )}




          {Notification}
        </>
      )
      }
    </>
  );
}
